export function getNetTaxTooltip(isTaxInputCreditRecoverable) {
  if (isTaxInputCreditRecoverable) {
    return "Tax input is recoverable, so tax paid is offset against tax collected (Net Tax = Tax Collected − Tax Paid). If tax paid is higher than tax collected, the surplus is credited back to profit - this can push Net Profit above Gross Profit.";
  }

  return "Tax input is non-recoverable, so only tax paid is considered and deducted in full from Gross Profit to calculate Net Profit. Tax collected is not offset.";
}
